<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ houseTypeTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ houseTypeSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!--typeHousingContract-->
            <div class="form-field">
                <p-selectButton
                    id="typeHousingContract"
                    formControlName="typeHousingContract"
                    class="p-selectButtonCustom"
                    [options]="typeHousingOptions"
                    optionLabel="name"
                    optionValue="code"
                    (onOptionClick)="onChangeTypeHousingContract($event)"
                ></p-selectButton>
            </div>

            <div class="more-options">
                <button *ngIf="!showMoreHouseType" ripple="true" class="more-options" type="button" (click)="onClickHouseType(true)">
                    <span class="more-options">{{ moreOptions | translate }}</span>
                </button>

                <button *ngIf="showMoreHouseType" ripple="true" class="more-options" type="button" (click)="onClickHouseType(false)">
                    <span class="more-options">{{ lessOptions | translate }}</span>
                </button>
            </div>

            <!--year-->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input type="text" class="input" formControlName="year" id="year" name="year" placeholder="" (keyup)="onChangeYear($event)" />
                        <label class="input-label" for="year">{{ yearFloatLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.year.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoYear | translate }}</span>
                    </div>
                </div>
            </div>

            <!--cost-->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input type="text" class="input" formControlName="cost" id="cost" name="cost" placeholder="" (keyup)="onChangeCost($event)" />
                        <label class="input-label" for="cost">{{ costFloatLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.cost.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoCost | translate }}</span>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
